import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { getRequestConfig } from 'src/queries/requestConfig'

import { GroupSSOConfig } from '../query/groupSsoConfig'

type SamlConfig = {
  groupId: string
  type: 'SAML'
  samlEntityId: string
  samlAcsUrl: string
  samlIdpSsoUrl: string
  samlIdpIssuer: string
  samlX509CertificatePem: string
}

/**
 * Creates SSO configuration for an organization.
 * This should act as an upsert
 * @API_TYPE - api.paywithextend.com
 * @endpoint POST /{organizationId}/settings/sso
 */
export function useCreateSSOConfiguration() {
  const mutation = useMutation({
    mutationFn: async (config: SamlConfig): Promise<GroupSSOConfig> => {
      const { groupId, ...rest } = config
      const requestBody = {
        ...rest,
        // TODO: Remove hardcoded value
        type: 'SAML',
      }
      const response = await axios.post(
        `/organizations/${groupId}/settings/sso`,
        requestBody,
        getRequestConfig(),
      )

      return response.data as GroupSSOConfig
    },
  })

  return mutation
}

export type EnableSSOResponse = unknown

/**
 * Enables or disables SSO for an organization
 * @API_TYPE - api.paywithextend.com
 * @endpoint PATCH /{organizationId}/sso/settings
 */
export function useEnableSSO() {
  const mutation = useMutation({
    mutationFn: async ({
      organizationId,
      enabled,
    }: {
      organizationId: string
      enabled: boolean
    }): Promise<EnableSSOResponse> => {
      const response = await axios.patch(
        `/organizations/${organizationId}/settings/sso`,
        { enabled },
        getRequestConfig(),
      )

      return response.data
    },
  })

  return mutation
}
